import { useEffect, useState } from 'react';

export const useHeaderItemClassName = () => {
  const [wrapNavigationItems, setWrapNavigationItems] = useState<boolean>(true);

  useEffect(() => {
    const handleResize = () => {
      setWrapNavigationItems(window.innerWidth <= 1250);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    headerItemClassName: wrapNavigationItems ? '' : 'u-ws-nowrap',
  };
};
